// DS: i4.12
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Recommended: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          d="M12.7247 20.1346L12 22l-.7247-1.8654a13 13 0 00-7.41-7.41L2 12l1.8654-.7247a13 13 0 007.41-7.41L12 2l.7247 1.8654a13 13 0 007.41 7.41L22 12l-1.8654.7247a13 13 0 00-7.41 7.41z"
          fillRule="evenodd"
        />
      </svg>
    </IconWrap>
  );
};
Recommended.displayName = 'Recommended';

export default Recommended;
